import { render } from "./reminder-form.vue?vue&type=template&id=b362d432"
import script from "./reminder-form.vue?vue&type=script&lang=js"
export * from "./reminder-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__